import { Injectable } from "@angular/core";
import {
  TalentJobOpportunity,
  TalentJobOpportunityDTO,
  TalentJobOpportunityFilter,
  TalentJobOpportunityFilterDTO,
  TalentJobOpportunityFormFilter,
} from "./talent-job-opportunity.types";

@Injectable({ providedIn: "root" })
export class TalentJobOpportunitySerializer {
  deserializeTalentJobOpportunity(dto: TalentJobOpportunityDTO): TalentJobOpportunity {
    return {
      jobOpportunityId: dto.jobOpportunityId,
      jobOpportunityName: dto.jobOpportunityName,
      description: dto.description,
      domainExpertise: dto.domainExpertise || [],
      department: dto.department || [],
      sectorFocus: dto.sectorFocus || [],
      industries: dto.industries || [],
      careerLevel: dto.careerLevel || [],
      workingModes: dto.workingModes || [],
      locations: dto.locations || [],
      creationTimestamp: dto.creationTimestamp,
      missionPartnerId: dto.missionPartnerId,
      conversationId: dto.conversationId,
    };
  }

  deserializeTalentJobOpportunities(dtos: TalentJobOpportunityDTO[]): TalentJobOpportunity[] {
    return dtos.map((dto) => this.deserializeTalentJobOpportunity(dto));
  }

  serializeTalentJobOpportunityFilter(filter: TalentJobOpportunityFilter): TalentJobOpportunityFilterDTO {
    const filters: Array<{ field: string; value: string }> = [];

    if (filter.sector) {
      filters.push({
        field: "SECTOR",
        value: filter.sector.value.toString(),
      });
    }

    if (filter.industry) {
      filters.push({
        field: "INDUSTRY",
        value: filter.industry.value.toString(),
      });
    }

    return {
      searchTerm: filter.searchTerm || "",
      filters,
      paging: {
        page: filter.paging.page - 1, // Convert to 0-based for API
        itemsOnPage: filter.paging.itemsOnPage,
      },
      sort: filter.sort || [
        {
          field: "REG_TIMESTAMP",
          order: "DESC",
        },
      ],
    };
  }

  serializeFormFilter(
    formFilter: TalentJobOpportunityFormFilter,
    paging: { page: number; itemsOnPage: number },
  ): TalentJobOpportunityFilterDTO {
    const filters: Array<{ field: string; value: string }> = [];

    if (formFilter.sector) {
      filters.push({
        field: "SECTOR",
        value: formFilter.sector.value.toString(),
      });
    }

    if (formFilter.industry) {
      filters.push({
        field: "INDUSTRY",
        value: formFilter.industry.value.toString(),
      });
    }

    return {
      searchTerm: formFilter.searchTerm || "",
      filters,
      paging: {
        page: paging.page - 1, // Convert to 0-based for API
        itemsOnPage: paging.itemsOnPage,
      },
      sort: [
        {
          field: "REG_TIMESTAMP",
          order: "DESC",
        },
      ],
    };
  }
}
